import BirthdayAndAnniversary1 from "../assets/MyEventCardImages/BirthdayAndAnniversary1.jpg";
import BirthdayAndAnniversary2 from "../assets/MyEventCardImages/BirthdayAndAnniversary2.jpg";
import BirthdayAndAnniversary3 from "../assets/MyEventCardImages/BirthdayAndAnniversary3.jpg";
import BirthdayAndAnniversary4 from "../assets/MyEventCardImages/BirthdayAndAnniversary4.jpg";
import BirthdayAndAnniversary5 from "../assets/MyEventCardImages/BirthdayAndAnniversary5.jpg";
import CommunityEvents1 from "../assets/MyEventCardImages/CommunityEvents1.jpg";
import CommunityEvents2 from "../assets/MyEventCardImages/CommunityEvents2.jpg";
import CommunityEvents3 from "../assets/MyEventCardImages/CommunityEvents3.jpg";
import CommunityEvents4 from "../assets/MyEventCardImages/CommunityEvents4.jpg";
import CommunityEvents5 from "../assets/MyEventCardImages/CommunityEvents5.jpg";
import CommunityEvents6 from "../assets/MyEventCardImages/CommunityEvents6.jpg";
import CommunityEvents7 from "../assets/MyEventCardImages/CommunityEvents7.jpg";
import CommunityEvents8 from "../assets/MyEventCardImages/CommunityEvents8.jpg";
import CommunityEvents9 from "../assets/MyEventCardImages/CommunityEvents9.jpg";
import CommunityEvents10 from "../assets/MyEventCardImages/CommunityEvents10.jpg";
import CommunityEvents11 from "../assets/MyEventCardImages/CommunityEvents11.jpg";
import CommunityEvents12 from "../assets/MyEventCardImages/CommunityEvents12.jpg";
import SportsEvents1 from "../assets/MyEventCardImages/SportsEvents1.jpg";
import SportsEvents2 from "../assets/MyEventCardImages/SportsEvents2.jpg";
import SportsEvents3 from "../assets/MyEventCardImages/SportsEvents3.jpg";
import SportsEvents4 from "../assets/MyEventCardImages/SportsEvents4.jpg";
import SchoolEvents1 from "../assets/MyEventCardImages/SchoolEvents1.jpg";
import SchoolEvents2 from "../assets/MyEventCardImages/SchoolEvents2.jpg";
import SchoolEvents3 from "../assets/MyEventCardImages/SchoolEvents3.jpg";
import ReligiousEvents1 from "../assets/MyEventCardImages/ReligiousEvents1.jpg";
import ReligiousEvents2 from "../assets/MyEventCardImages/ReligiousEvents2.jpg";
import ReligiousEvents3 from "../assets/MyEventCardImages/ReligiousEvents3.jpg";
import ReligiousEvents4 from "../assets/MyEventCardImages/ReligiousEvents4.jpg";
import PrivateEvent1 from "../assets/MyEventCardImages/PrivateEvent1.jpg";
import PrivateEvent2 from "../assets/MyEventCardImages/PrivateEvent2.jpg";
import PrivateEvent3 from "../assets/MyEventCardImages/PrivateEvent3.jpg";
import PrivateEvent4 from "../assets/MyEventCardImages/PrivateEvent4.jpg";
import PrivateEvent5 from "../assets/MyEventCardImages/PrivateEvent5.jpg";
import PrivateEvent6 from "../assets/MyEventCardImages/PrivateEvent6.jpg";
import CulturalEvents1 from "../assets/MyEventCardImages/CulturalEvents1.jpg";
import CulturalEvents2 from "../assets/MyEventCardImages/CulturalEvents2.jpg";
import CulturalEvents3 from "../assets/MyEventCardImages/CulturalEvents3.jpg";
import CulturalEvents4 from "../assets/MyEventCardImages/CulturalEvents4.jpg";
import CorporateEvent1 from "../assets/MyEventCardImages/CorporateEvent1.jpg";
import CorporateEvent2 from "../assets/MyEventCardImages/CorporateEvent2.jpg";
import CorporateEvent3 from "../assets/MyEventCardImages/CorporateEvent3.jpg";
import CorporateEvent4 from "../assets/MyEventCardImages/CorporateEvent4.jpg";
import CorporateEvent5 from "../assets/MyEventCardImages/CorporateEvent5.jpg";
import CorporateEvent6 from "../assets/MyEventCardImages/CorporateEvent6.jpg";
import CorporateEvent7 from "../assets/MyEventCardImages/CorporateEvent7.jpg";
import CorporateEvent8 from "../assets/MyEventCardImages/CorporateEvent8.jpg";
import CorporateEvent9 from "../assets/MyEventCardImages/CorporateEvent9.jpg";
import Wedding1 from "../assets/MyEventCardImages/Wedding1.jpg";
import Wedding2 from "../assets/MyEventCardImages/Wedding2.jpg";
import Wedding3 from "../assets/MyEventCardImages/Wedding3.jpg";
import Wedding4 from "../assets/MyEventCardImages/Wedding4.jpg";
import ThemeParty1 from "../assets/MyEventCardImages/ThemeParty1.jpg";
import ThemeParty2 from "../assets/MyEventCardImages/ThemeParty2.jpg";
import ThemeParty3 from "../assets/MyEventCardImages/ThemeParty3.jpg";

const DefaultImage =
  "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&q=80";

// Image arrays for each event type
const weddingImages = [Wedding1, Wedding2, Wedding3, Wedding4];
const corporateImages = [
  CorporateEvent1,
  CorporateEvent2,
  CorporateEvent3,
  CorporateEvent4,
  CorporateEvent5,
  CorporateEvent6,
  CorporateEvent7,
  CorporateEvent8,
  CorporateEvent9,
];
const communityImages = [
  CommunityEvents1,
  CommunityEvents2,
  CommunityEvents3,
  CommunityEvents4,
  CommunityEvents5,
  CommunityEvents6,
  CommunityEvents7,
  CommunityEvents8,
  CommunityEvents9,
  CommunityEvents10,
  CommunityEvents11,
  CommunityEvents12,
];
const privateImages = [
  PrivateEvent1,
  PrivateEvent2,
  PrivateEvent3,
  PrivateEvent4,
  PrivateEvent5,
  PrivateEvent6,
];
const culturalImages = [
  CulturalEvents1,
  CulturalEvents2,
  CulturalEvents3,
  CulturalEvents4,
];
const religiousImages = [
  ReligiousEvents1,
  ReligiousEvents2,
  ReligiousEvents3,
  ReligiousEvents4,
];
const schoolImages = [SchoolEvents1, SchoolEvents2, SchoolEvents3];
const sportsImages = [
  SportsEvents1,
  SportsEvents2,
  SportsEvents3,
  SportsEvents4,
];
const birthdayImages = [
  BirthdayAndAnniversary1,
  BirthdayAndAnniversary2,
  BirthdayAndAnniversary3,
  BirthdayAndAnniversary4,
  BirthdayAndAnniversary5,
];
const themePartyImages = [ThemeParty1, ThemeParty2, ThemeParty3];

// Deterministic hash -> index helper
const deterministicIndex = (seedString, modulo) => {
  if (!modulo || modulo <= 0) return 0;
  const str = (seedString || "").toString();
  let hash = 5381; // djb2
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) + hash + str.charCodeAt(i);
    hash |= 0; // force 32-bit
  }
  const idx = Math.abs(hash) % modulo;
  return idx;
};

// Map event types to arrays
const eventImagesMap = {
  // Main event types from EventForm
  Wedding: weddingImages,
  "Corporate Event": corporateImages,
  "Community Event": communityImages,
  "Private Event": privateImages,
  Holidays: communityImages,
  "Theme Party": themePartyImages,
  "Birthdays & Anniversaries": birthdayImages,
  "Cultural Events": culturalImages,
  "Religious Events": religiousImages,
  "School Events": schoolImages,
  "Sporting Events": sportsImages,
  // Legacy/alternative naming support
  wedding: weddingImages,
  corporate: corporateImages,
  community: communityImages,
  sports: sportsImages,
  school: schoolImages,
  Birthday: birthdayImages,
  birthday: birthdayImages,
  Conference: corporateImages,
  conference: corporateImages,
  Party: communityImages,
  party: communityImages,
  private: privateImages,
  cultural: culturalImages,
  religious: religiousImages,
  theme: themePartyImages,
};

// Deterministic image selection based on eventType and optional seed
export const getEventImage = (eventType, seed) => {
  const images = eventImagesMap[eventType];
  if (Array.isArray(images) && images.length > 0) {
    const selectionSeed = (seed ?? eventType ?? "").toString();
    const idx = deterministicIndex(selectionSeed, images.length);
    return images[idx];
  }
  return DefaultImage;
};

export { DefaultImage };
